import { render, staticRenderFns } from "./PayAccessChart.vue?vue&type=template&id=3247d8d2&scoped=true&"
import script from "./PayAccessChart.vue?vue&type=script&lang=js&"
export * from "./PayAccessChart.vue?vue&type=script&lang=js&"
import style0 from "./PayAccessChart.vue?vue&type=style&index=0&id=3247d8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247d8d2",
  null
  
)

component.options.__file = "PayAccessChart.vue"
export default component.exports